export const Roles = [
  { key: 'Administrator', value: 'administrator' },
  { key: 'Ekome Publisher', value: 'ekome_publisher' },
  { key: 'Ekome Editor', value: 'ekome_editor' },
  { key: 'Film Office Publisher', value: 'film_office_publisher' },
  { key: 'Film Office Editor', value: 'film_office_editor' },
];

export const administrator_options = [
  { key: 'ΕΚΟΜΕ- Διεύθυνση Πληροφορικής', value: 'administrator' }
];
export const ekome_publisher_options = [
  { key: 'ΕΚΟΜΕ-Διεύθυνση Επένδυσης', value: 'administrator' },
  { key: 'EΚΟΜΕ-Διεύθυνση Ψηφιοποίησης', value: 'ekome_publisher' },
  { key: 'EKOME-Διεύθυνση Εκπαίδευσης', value: 'ekome_editor' }
];

export const ekome_editor_options = [
  { key: 'ΕΚΟΜΕ-Διεύθυνση Επένδυσης', value: 'administrator' },
  { key: 'ΕΚΟΜΕ-Διεύθυνση Ψηφιοποίησης', value: 'ekome_publisher' },
  { key: 'EKOME-Διεύθυνση Εκπαίδευσης', value: 'ekome_editor' }
];

export const film_office_publisher_options = [
  { key: 'Film Office Aνατολικής Μακεδονίας και Θράκης', value: 'random_value_until_confirmation' },
  { key: 'Film Office Κεντρικής Μακεδονίας', value: 'random_value_until_confirmation1' },
  { key: 'Film Office Δυτικής Μακεδονίας', value: 'random_value_until_confirmation2' },
  { key: 'Film Office Ηπείρου', value: 'random_value_until_confirmation3' },
  { key: 'Film Office Θεσσαλίας', value: 'random_value_until_confirmation4' },
  { key: 'Film Office Ιονίων Νήσων', value: 'random_value_until_confirmation5' },
  { key: 'Film Office Δυτικής Ελλάδας', value: 'random_value_until_confirmation6' },
  { key: 'Film Office Στερεάς Ελλάδας', value: 'random_value_until_confirmation7' },
  { key: 'Film Office Αττικής', value: 'random_value_until_confirmation8' },
  { key: 'Film Office Πελοποννήσου', value: 'random_value_until_confirmation9' },
  { key: 'Film Office Βορείου Αιγαίου', value: 'random_value_until_confirmation10' },
  { key: 'Film Office Νοτίου Αιγαίου', value: 'random_value_until_confirmation11' },
  { key: 'Film Office Κρήτης', value: 'random_value_until_confirmation12' },
  { key: 'Film Office Αθήνας', value: 'random_value_until_confirmation13' },
  { key: 'Film Office Θεσσαλονίκης', value: 'random_value_until_confirmation14' },
];
export const film_office_editor_options = [
  { key: 'Film Office Aνατολικής Μακεδονίας και Θράκης', value: 'random_value_until_confirmation' },
  { key: 'Film Office Κεντρικής Μακεδονίας', value: 'random_value_until_confirmation' },
  { key: 'Film Office Δυτικής Μακεδονίας', value: 'random_value_until_confirmation' },
  { key: 'Film Office Ηπείρου', value: 'random_value_until_confirmation' },
  { key: 'Film Office Θεσσαλίας', value: 'random_value_until_confirmation' },
  { key: 'Film Office Ιονίων Νήσων', value: 'random_value_until_confirmation' },
  { key: 'Film Office Δυτικής Ελλάδας', value: 'random_value_until_confirmation' },
  { key: 'Film Office Στερεάς Ελλάδας', value: 'random_value_until_confirmation' },
  { key: 'Film Office Αττικής', value: 'random_value_until_confirmation' },
  { key: 'Film Office Πελοποννήσου', value: 'random_value_until_confirmation' },
  { key: 'Film Office Βορείου Αιγαίου', value: 'random_value_until_confirmation' },
  { key: 'Film Office Νοτίου Αιγαίου', value: 'random_value_until_confirmation' },
  { key: 'Film Office Κρήτης', value: 'random_value_until_confirmation' },
  { key: 'Film Office Αθήνας', value: 'random_value_until_confirmation' },
  { key: 'Film Office Θεσσαλονίκης', value: 'random_value_until_confirmation' },
];

export const Administrative_Units_Status = [
  { key: 'Ανενεργή', value: false },
  { key: 'Ενεργή', value: true },
];

export const User_Units_Status = [
  { key: 'Ανενεργός', value: false },
  { key: 'Ενεργός', value: true },
];

export const User_Units_Status_Out = [
  { key: 'Αποκλεισμένος', value: false },
  { key: 'Ενεργός', value: true },
];

export const Auth_Method = [
  { key: 'Email', value: 'Email/Password' },
  { key: 'Facebook', value: 'Facebook' },
  { key: 'Google', value: 'Google' },
  { key: 'Microsoft', value: 'Microsoft' },
  { key: 'TaxisNet', value: 'Taxis OAuth' },
];

export const Application_Status = [
  { key: 'Όλες', value: 'all' },
  { key: 'Αποθηκευμένο', value: 'draft' },
  { key: 'Υπό Διεκπεραίωση', value: 'in_progress' },
  { key: 'Σε επικαιροποίηση', value: 'under_update' },
  { key: 'Απορριφθέν', value: 'rejected' },
  { key: 'Επιτυχές', value: 'successful' }
];

export const AdtKindOptions = [
  { value: 0, key: 'ΑΓΝΩΣΤΗ' },
  { value: 1, key: 'ΑΤ ΑΣΤΥΝΟΜΙΚΗ ΤΑΥΤΟΤΗΤΑ' },
  { value: 2, key: 'ΕΣ ΕΛΛΗΝΙΚΟΣ ΣΤΡΑΤΟΣ' },
  { value: 3, key: 'ΠΝ ΠΟΛΕΜΙΚΟ ΝΑΥΤΙΚΟ' },
  { value: 4, key: 'ΠΑ ΠΟΛΕΜΙΚΗ ΑΕΡΟΠΟΡΙΑ' },
  { value: 5, key: 'ΕΑ ΕΛΛΗΝΙΚΗ ΑΣΤΥΝΟΜΙΑ' },
  { value: 6, key: 'ΛΣ ΛΙΜΕΝΙΚΟ ΣΩΜΑ' },
  { value: 7, key: 'ΠΣ ΠΥΡΟΣΒΕΣΤΙΚΟ ΣΩΜΑ' },
  { value: 8, key: 'ΔΙ ΔΙΑΒΑΤΗΡΙΟ' },
  { value: 9, key: 'ΚΑ ΚΕΝΤΡΟ ΑΛΛΟΔΑΠΩΝ' },
  { value: 10, key: 'ΧΤ ΧΩΡΙΣ ΤΑΥΤΟΤΗΤΑ' },
  { value: 11, key: 'ΕΝΤΟΛΕΑΣ ΦΠ' },
  { value: 12, key: 'ΚΠ ΚΑΡΤΑ ΠΑΡΑΜΟΝΗΣ ΠΕΡΙΟΡ ΧΡΟΝ ΔΙΑΡΚ' },
  { value: 13, key: 'ΤΑΥΤΟΤΗΤΑ ΕΥΡΩΠΑΙΚΗΣ ΕΝΩΣΗΣ' },
  { value: 14, key: 'ΤΑΥΤΟΤΗΤΑ ΑΝΙΘΑΓΕΝΗ(Ν.139/1975)' },
  { value: 15, key: 'ΤΑΥΤΟΤΗΤΑ ΟΜΟΓΕΝΟΥΣ' },
  { value: 16, key: 'ΑΡΙΘΜΟΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ ΗΠΑ' },
  { value: 17, key: 'ΕΔΤ ΠΟΛΙΤΙΚΟΥ ΠΡΟΣΦΥΓΑ ΥΠΟ ΑΝΑΓΝΩΡΙΣΗ' },
  { value: 18, key: 'ΕΙΔΙΚΟ ΔΕΛΤΙΟ ΠΟΛΙΤΙΚΟΥ ΦΥΓΑΔΑ' },
  { value: 19, key: 'ΑΔΕΙΑ ΠΑΡΑΜΟΝΗΣ ΠΡΟΣΦΥΓΑ ΑΤΕΛΩΣ' },
  { value: 20, key: 'ΕΙΔΙΚΟ ΔΕΛΤΙΟ ΠΡΟΣΦΥΓΑ ΑΝΘΡΩΠ ΚΑΘΕΣΤΩΤΟΣ' },
  { value: 21, key: 'ΤΑΥΤΟΤΗΤΑ ΑΛΛΟΔΑΠΟΥ ΚΡΑΤΟΥΜΕΝΟΥ' },
  { value: 22, key: 'ΠΙΣΤΟΠΟΙΗΤΙΚΟ ΓΕΝΝΗΣΗΣ ΑΛΛΟΔΑΠΟΥ' },
  { value: 23, key: 'ΤΑΥΤΟΤΗΤΑ ΧΩΡΑΣ ΕΚΤΟΣ ΕΥΡΩΠΑΙΚΗΣ ΕΝΩΣΗΣ' },
  { value: 24, key: 'ΑΓ ΕΛΛΗΝΙΚΗ ΑΓΡΟΦΥΛΑΚΗ' },
  { value: 25, key: 'ΔΕΛΤΙΟ ΑΙΤΟΥΝΤΟΣ ΔΙΕΘΝΗ ΠΡΟΣΤΑΣΙΑ' },
  { value: 26, key: 'ΑΔΕΙΑ ΔΙΑΜ ΥΠΗΚ ΤΡΙΤ ΧΩΡ ΧΩΡΙΣ ΔΙΑΒΑΤ' },
  { value: 27, key: 'ΑΔΕΤ/ΔΙΚΑΙΟΥΧΟΣ ΔΙΕΘΝΟΥΣ ΠΡΟΣΤΑΣΙΑΣ' },
  { value: 28, key: 'ΤΑΞΙΔΙΩΤΙΚΟ ΕΓΓΡΑΦΟ' },
];